module.exports = __webpack_public_path__ + "img/jp.ce347c9c.png";